import FaceRecon from '../../assets/face-recon.webp'
import NeuralNetwork from '../../assets/nn.png'
export const mlprojects = [
  {
    image: FaceRecon,
    title: "Facial Recognition",
    href: "https://github.com/Connor-Underwood/FaceRecon.git",
    description:
      "Facial recognition software built leveraging the OpenCV library.",
    tags: ["Python", "OpenCV"],
  },
  {
    image:NeuralNetwork,
    title: "Neural Network",
    href: "https://github.com/Connor-Underwood/Neural-Network",
    description:
      "A 98% accurate digit classifying multi-layer perceptron built from scratch in vanilla Python & Numpy.",
    tags: ["Python", "Numpy"],
  }
];